module.exports = __webpack_public_path__ + "img/bi.6f9ea73e.svg";